import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function DateRangePicker({passStartDate, passEndDate}) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);



  function handleDateChange(date, type) {
    if (type === 'start') {
      // convertMonthAbbreviationToNumber()
      
      const str = JSON.stringify(date);
      const start_month = str.substring(6, 8);

      const start_year = str.substring(1,5)
      
      let fin_start_date = start_month + "/" + start_year
      
      setStartDate(date);
      passStartDate(fin_start_date)
    } else {
      const str2 = JSON.stringify(date);
      const end_month = str2.substring(6, 8);

      const end_year = str2.substring(1,5)
      
      let fin_end_date = end_month + "/" + end_year
      

      setEndDate(date);
      passEndDate(fin_end_date);
    }
  }


  // const maxDate = new Date('2023-12-31');

  return (
    <div>
      <label>From:</label>
      <DatePicker
        selected={startDate}
        onChange={(date) => handleDateChange(date, 'start')}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        maxDate={new Date("2017-12-31")}
        minDate={new Date("2010-01-01")}
      />
      <label>To:</label>
      <DatePicker
        selected={endDate}
        onChange={(date) => handleDateChange(date, 'end')}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        maxDate={new Date("2017-12-31")}
        // maxDate={maxDate}
      />
    </div>
  );
}

export default DateRangePicker;
